module.exports = __webpack_public_path__ + "img/4064005000.e3a08294.jpg";